import { Button, Flex, Layout, Typography, theme, Modal, Form, message, Table, Skeleton } from 'antd'
import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'
import { PlusOutlined } from '@ant-design/icons'
import AddConsultantForm from '../../components/consultant/AddConsultantForm'
import consultantService from '../../services/consultantService'
import { useNavigate } from 'react-router-dom'
const { Content } = Layout

// const customHeader = {
//   backgroundColor:'#D7E3F1'
// }
const tableColumns = [
  {
    // title: <div style={customHeader}>S.No</div>,
    title: 'S.No',
    dataIndex: 'number',
    key: 'number',
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Created at',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
  {
    title: 'Companies',
    dataIndex: 'companies',
    key: 'companies',
  },
];

const Consultants = () => {

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [openModal, setOpenModal] = useState(false)
  const [form] = Form.useForm()

  const navigate = useNavigate()

  const [contentLoading, setContentLoading] = useState(true)
  const [page,setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  const [messageApi, contextHolder] = message.useMessage();
  const key = 'updatable';

  const [consultantsData, setConsultantsData] = useState([])
  const [consultantDataSize,setConsultantDataSize] = useState(0)

  const handleCompaniesView = (consultantId) => {
    navigate(`/consultant/${consultantId}/companies`)
  }

  const fetchConsultants = () => {
    setContentLoading(true)
    consultantService.getAllConsultants()
      .then((response) => {
        const data = response?.data.map(({id, userName, email, createdAt}, i) => ({ 
          key: id, 
          number: i+1, 
          name: userName, 
          email, createdAt, 
          companies: <Button type='default' style={{color:'#18A07A', backgroundColor:'#DDF8EE', padding:'6px 12px 6px 12px', borderRadius:'5px', fontSize:'14px' ,border:'none' }} onClick={() => handleCompaniesView(id)}>View</Button> 
        }))
        setConsultantsData(data)
        setConsultantDataSize(data.length);
        console.log("func k ander: ",consultantDataSize)
      })
      .catch((error) => console.log(error))
      .finally(() => setContentLoading(false))
  }

  useEffect(() => {
    fetchConsultants()
  }, [])

  const handleClose = () => {
    form.resetFields()
    setOpenModal(false)
  }

  // const TableHeader = () => (
  //   <thead style={{ backgroundColor: '##D7E3F1' }}>
  //     <tr>
  //       {tableColumns.map((column) => (
  //         <th key={column.key}>{column.title}</th>
  //       ))}
  //     </tr>
  //   </thead>
  // );

 
  console.log("func k bahar: ",consultantDataSize)

  return (
    <>
      {contextHolder}
      <Layout style={{minHeight: '100vh'}}>
        <Header bgColor={colorBgContainer}/>
        <Content
          style={{
            padding: '0 48px',
          }}
        >
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 36,
              borderRadius: 15,
              marginTop: 35,
              display:'flex',
              flexDirection:'column',
              gap:'30px'
            }}
          >
            
            <Flex style={{ width: '100%' }} justify={'space-between'} align={'center'}>
              {/* <Button type="dashed" icon={<PlusOutlined />} onClick={() => setOpenModal(true)}>Add Consultant</Button> */}
              <Typography.Title style={{color:'#07224D', fontWeight:'700', fontSize:'25px', marginBottom:'0px' }}>
              Consultants
            </Typography.Title>
              <Button
                  style={{
                    backgroundColor: "#3BA4FE",
                    padding: "20px 32px 20px 32px",
                    color: "#FFFFFF",
                    fontSize: "18px",
                    height: "62px",
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '10px',
                    fontWeight: '700'
                  }}
                  type="primary"
                  icon={<PlusOutlined style={{fontWeight:700}}/>}
                  onClick={() => setOpenModal(true)}
                >
                  Add Consultant
                </Button>
            </Flex>
            <Skeleton active={true} loading={contentLoading}>
              <div style={{border:'1px solid #D7E3F1', borderRadius:'15px 15px 15px 15px', background: '#ffffff'}} >
              <Table style={{margin:'16px 16px 0px 0px', background:'#D7E3F1' ,background: '#ffffff' }} columns={tableColumns} dataSource={consultantsData}
               pagination={{
                current:page ,
                pageSize:pageSize, 
                total:consultantDataSize,
                onChange:(page,pageSize)=>{
                  setPage(page);
                  setPageSize(pageSize)
                }}}
                 />
                <p style={{fontSize:'16px', color:'#8A8A95', marginTop:'-25px', padding:'0px 32px 0px 16px'}}>showing 1 to 10 of {consultantDataSize}</p>
              </div>
            </Skeleton>
            <Modal
              title="Add New Consultant"
              open={openModal}
              onCancel={handleClose}
              mask={true}
              maskClosable={false}
              footer={null}
            >
              <AddConsultantForm form={form} handleClose={handleClose} messageApi={messageApi} messageKey={key} fetchConsultants={fetchConsultants}/>
            </Modal>
          </div>
        </Content>
        <Footer/>
      </Layout>
    </>
  )
}

export default Consultants